import React from 'react';
import { t } from 'ttag';
import Grid from '@material-ui/core/Grid';
import { MTableToolbar } from 'material-table';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import FilterListIcon from '@material-ui/icons/FilterList';
import DataTable from '../../../components/DataTable';
import { useApolloClient } from '@apollo/react-hooks';
import { MyClubCApi } from '../../../api';
import { DatePicker } from '@material-ui/pickers';
import { nexYear } from '../../../utils/helpers';

const SectionStats = ({ year, onChangeYear }) => {
  const client = useApolloClient();
  const newApi = new MyClubCApi(client);
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    fetchPageData();
  }, [year]);

  const fetchPageData = async () => {
    setLoading(true);
    const res = await newApi.getStatsSections({ year: year });
    setData(res);
    setLoading(false);
  };

  const handleChangeYear = async (e) => {
    onChangeYear(String(e.getFullYear()));
  };

  const columns = [
    { title: t`Вид спорту`, field: 'sectionName', editable: 'never' },
    { title: t`Кількість активних членів`, field: 'countMembers' },
    { title: t`Сума внесків`, field: 'sumContributions' },
    { title: t`Кількість членів сплатили внесок`, field: 'countPaidMembers' },
    {
      title: t`Частка %`,
      field: 'percent',
      render: (obj) => `${obj.percent.toFixed(2)} %`,
    },
  ];

  return (
    <DataTable
      search={false}
      isLoading={loading}
      title={t`Статистика за видами спорту`}
      columns={columns}
      data={data}
      customRowStyle={(rowData) => {
        return {
          backgroundColor: rowData.sectionId !== 0 ? '#fff' : '#eee',
        };
      }}
      components={{
        Pagination: () => (
          <Grid container style={{ marginTop: '10px', marginBottom: '10px' }} />
        ),
        Toolbar: (props) => (
          <div style={{ flexGrow: 1 }}>
            <MTableToolbar {...props} />
            <Grid
              container
              spacing={2}
              style={{ marginLeft: '10px' }}
              justifyContent='flex-start'
              alignItems='center'
            >
              <Grid item>
                <Tooltip title={t`Виберіть фільтр`}>
                  <FilterListIcon />
                </Tooltip>
              </Grid>
              <Grid item sm={4}>
                <DatePicker
                  size={'small'}
                  variant='inline'
                  label={t`Рік внеску`}
                  InputAdornmentProps={{ position: 'start' }}
                  inputVariant='outlined'
                  openTo='year'
                  format='yyyy'
                  views={['year']}
                  value={year}
                  cancelLabel='Відмінити'
                  maxDate={nexYear()}
                  onChange={handleChangeYear}
                />
              </Grid>
            </Grid>
          </div>
        ),
      }}
    />
  );
};

export default SectionStats;
